import { render, staticRenderFns } from "./TutorialList.vue?vue&type=template&id=06377c4e&scoped=true"
import script from "./TutorialList.vue?vue&type=script&lang=js"
export * from "./TutorialList.vue?vue&type=script&lang=js"
import style0 from "./TutorialList.vue?vue&type=style&index=0&id=06377c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06377c4e",
  null
  
)

export default component.exports